<template>
  <div class="plist-container" v-show="showPlistTips">
    <img src="../../assets/images/plist_wx_flow.jpg" class="wx_flow_img">
  </div>
</template>
<script>

export default {
  name: 'plistTips',
  //ref=plistTipsView
  //successFun=gameSelSuc
  props: {},
  data() {
    return {
      showPlistTips: false,
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    showPlistTipsView() {
      this.showPlistTips = true;
    },
  }
}
</script>

<style scoped lang='less'>
.plist-container {
  position: fixed;
  z-index: 1;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #fff;
  overflow: auto;
}

.plist-container img {
  width: 100%;
}

.wx_flow_img {
  position: absolute;
  top: 0px;
  left: 0;
}
</style>


// WEBPACK FOOTER //
// plistTips.vue?0ee0c008